fx.ns("repositories", class ThemeCategoriesRepository extends fx.ModelArray {

    constructor()
    {
        super([]);

        this.endpoint = "/app/themes";

        this._tags = [];
    }

    get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

    load()
    {
        this.post( 
            { 
                action:"categories"
            }, 
            this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
            this.event("connection-error", data);
        else
            this.addItem(data, false);
        
    }

});
